import Cookies from 'js-cookie'

export const getTokenFromCookies = () => {
  const data = Cookies.get('token')
  return data ?? null
}

export const resetTokenFromCookies = () => {
  Cookies.remove('token')
}
